<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="6">
            <v-card class="elevation-10">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Blue Business Guide</v-toolbar-title>
              </v-toolbar>
              <v-progress-linear
                absolute
                :active="loading"
                indeterminate
                color="primary"
                bottom
              ></v-progress-linear>
              <v-card-text>
                <v-form>
                  <v-text-field
                    :error="emailError"
                    :error-messages="emailErrorMessage"
                    v-model="email"
                    label="Login"
                    name="username"
                    prepend-icon="mdi-account"
                    type="text"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    :error="passwordError"
                    :error-messages="passwordErrorMessage"
                    v-model="password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    outlined
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-checkbox label="Remember Me" v-model="remember"></v-checkbox>
                <v-spacer></v-spacer>
                <v-btn :disabled="loading" @click="login()" color="primary"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { axios } from '../utils'

import { mapActions } from 'vuex'
export default {
  data: () => ({
    loading: false,
    remember: false,
    email: '',
    emailError: false,
    emailErrorMessage: '',
    password: '',
    passwordError: false,
    passwordErrorMessage: ''
  }),
  methods: {
    ...mapActions(['setUser', 'setRole']),
    login() {
      this.loading = true
      // reset previous errors
      this.emailError = false
      this.passwordError = false
      this.emailErrorMessage = ''
      this.passwordErrorMessage = ''
      axios
        .get('/sanctum/csrf-cookie')
        .then(() => {
          axios
            .post('login', {
              email: this.email,
              password: this.password,
              remember: this.remember
            })
            .then(() => {
              axios
                .get('api/user')
                .then(res => {
                  console.log(res, res.data)
                  const user = res.data
                  window.localStorage.setItem('user', JSON.stringify(user))
                  window.localStorage.setItem('role', user.roles[0].name)

                  this.setRole(user.roles[0].name)
                  this.setUser(user)

                  console.log('user', user)
                  if (user.roles[0].name === 'admin') {
                    this.$router.push('/')
                  } else if (user.roles[0].name === 'salesRep') {
                    this.$router.push('/business')
                  }
                })
                .catch(err => {
                  console.log(err)
                  this.loading = false
                })
            })
            .catch(error => {
              console.log('login error')
              this.loading = false

              const status = error?.response?.status
              const errors = error?.response?.data?.errors || {}

              // Validation errors
              if (errors.email && errors.email.length) {
                this.emailError = true
                this.emailErrorMessage = errors.email[0]
              }
              if (errors.password && errors.password.length) {
                this.passwordError = true
                this.passwordErrorMessage = errors.password[0]
              }

              // Invalid credentials (Laravel typically returns 401/422 without field errors)
              if (
                (!errors.email && !errors.password) &&
                (status === 401 || status === 422)
              ) {
                this.emailError = true
                this.passwordError = true
                const msg = 'Invalid email or password.'
                this.emailErrorMessage = msg
                this.passwordErrorMessage = msg
              }
            })
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    }
  },
  mounted() {
    axios.get('api/user').then(res => {
      console.log(res, res.data)
      if (
        res.data.roles[0].name === 'admin' ||
        res.data.roles[0].name === 'salesRep'
      ) {
        window.localStorage.setItem('user', JSON.stringify(res.data))
        window.localStorage.setItem('role', res.data.roles[0].name)

        this.setRole(res.data.roles[0].name)
        this.setUser(res.data)

        res.data.roles[0].name === 'admin'
          ? this.$router.push('/')
          : this.$router.push('/business')
      }
    })
  },

  watch: {
    email: function() {
      this.emailError = false
      this.emailErrorMessage = ''
    },
    password: function() {
      this.passwordError = false
      this.passwordErrorMessage = ''
    }
  }
}
</script>
<style lang="scss" scoped></style>
